import { render } from "./helpView.vue?vue&type=template&id=195b4a78&scoped=true"
import script from "./helpView.vue?vue&type=script&lang=js"
export * from "./helpView.vue?vue&type=script&lang=js"

import "./helpView.vue?vue&type=style&index=0&id=195b4a78&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195b4a78"]])

export default __exports__